
let VisitorType = {
    visitors: "getVisitors",
};

export default VisitorType;